// ConsultantShareMonthlyView.jsx — 상담자배분 창 [월별 실적] 탭 (2026-10-05 사용자 요청)
//   "상담자 배분에 해당하는 것만" — [배분 내역] 목록과 같은 계약을 차감 영업자·짝꿍 마케터·상담자 × 월로 본다.
//   탭을 눌렀을 때만 불러온다(서버 marketer-consultant-share-monthly.service.js).
import React, { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { currentYearKST, todayKST } from '../../../utils/date';
import { withIntegratedMenu } from './ConsultantShareLedgerModal.helpers';
import { ConsultantShareMonthlyTable } from './ConsultantShareMonthlyTable';
import { S } from './ConsultantShareLedgerModal.styles';
import { M } from './ConsultantShareMonthly.styles';

export function ConsultantShareMonthlyView({ companyCode, integratedMenuId, compact }) {
  const thisYear = currentYearKST();
  const [year, setYear] = useState(thisYear);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    const url = `/api/admin/marketer-consultant/consultant-share-monthly?company_code=${encodeURIComponent(companyCode || '')}&year=${year}`;
    const res = await apiClient.get(withIntegratedMenu(url, integratedMenuId));
    setLoading(false);
    if (!res.ok || !res.data?.success) {
      setData(null);
      setError(res.data?.message || '월별 실적을 불러오지 못했습니다.');
      return;
    }
    setData(res.data.data || null);
  }, [companyCode, integratedMenuId, year]);

  useEffect(() => { load(); }, [load]);

  const firstYear = data?.firstYear || thisYear;
  const currentYm = todayKST().slice(0, 7);
  const canPrev = !loading && year > firstYear;
  const canNext = !loading && year < thisYear;

  return (
    <>
      <div style={M.yearBar}>
        <div style={M.yearNav}>
          <button type="button" style={M.yearBtn(!canPrev)} disabled={!canPrev} onClick={() => setYear((y) => y - 1)} aria-label="이전 해">‹</button>
          <span style={M.yearLabel}>{year}년</span>
          <button type="button" style={M.yearBtn(!canNext)} disabled={!canNext} onClick={() => setYear((y) => y + 1)} aria-label="다음 해">›</button>
        </div>
        <button type="button" style={S.reloadBtn} onClick={load} disabled={loading}>
          {loading ? '불러오는 중' : '새로고침'}
        </button>
      </div>
      <div style={M.note}>
        [배분 내역] 목록과 같은 계약만 셉니다. 칸은 <b>건수 / 장수 / 배분금</b>입니다. 장수는 상품관리 환산장수(계약일에 적용되던 배수), 배분금은 목록의 배분금액이고, 날짜는 계약일 기준입니다.
        취소된 계약은 취소한 달에서 뺍니다.
        {data?.excludedCount > 0 && <> 제외 처리한 {data.excludedCount}건은 세지 않았습니다.</>}
      </div>
      {error && <div style={S.error}>{error}</div>}
      {loading && !data && <div style={S.empty}>불러오는 중입니다.</div>}
      {data && (data.tables || []).map((table) => (
        <ConsultantShareMonthlyTable
          key={`${data.year}-${table.key}`}
          table={table}
          months={data.months || []}
          currentYm={currentYm}
          compact={compact}
        />
      ))}
    </>
  );
}
